import { useState, useEffect } from 'react';
import { CompanyTag } from '../types/companyTags';
import apiClient from '../api/client';

// Hook to get all active company tags
export const useCompanyTags = () => {
  const [data, setData] = useState<CompanyTag[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchCompanyTags = async () => {
      try {
        const response = await apiClient.get('/api/v1/company-tags');
        setData(response.data.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch company tags'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanyTags();
  }, []);

  return { data, isLoading, error };
};